<template>
  <div class="pages">
    <div class="cont">
      <div class="title_text">
        {{ newData.orgName }}
      </div>
      <div class="money">￥ {{ newData.ownpayAmt }}</div>
      <div class="btnPay" @click="goPay">立即支付</div>
      <div style="margin: 40px 0 0;">
        <div class="text_bottom">
          <div class="font_text">总金额</div>
          <div class="font_text">{{ newData.feeSumamt }}</div>
        </div>
        <div class="text_bottom">
          <div class="font_text">医保支付</div>
          <div class="font_text">{{ newData.fundPay }}</div>
        </div>
        <div class="text_bottom">
          <div class="font_text">个人账户支付</div>
          <div class="font_text">{{ newData.psnAcctPay }}</div>
        </div>
        <div class="text_bottom">
          <div class="font_text">合计待支付</div>
          <div class="font_text">￥{{ newData.ownpayAmt }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  YBPayCallBck,
  GetItem,
  WeiXinChargeTwo,
  NoSelfPayment
} from "@/services/getData.js";
import weui from "weui.js";
export default {
  data() {
    return {
      newData: {}
    };
  },
  created() {
    this.getData();
  },
  watch: {},
  methods: {
    getData() {
      const mode = {};
      const url = this.$route.fullPath.split("?")[1];
      const kv = url.split("&");
      for (var i = 0; i < kv.length; i++) {
        const valueKey = kv[i].split("=")[0];
        const value = kv[i].split("=")[1];
        mode[valueKey] = value;
      }
      YBPayCallBck(mode).then(res => {
        if (res.data.Result == false) {
          alert(res.data.Content);
          return false;
        } else {
          this.newData = res.data.Extend;
        }
      });
    },
    goPay() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      const data = {
        MedOrdOrd: this.newData.medOrdOrd,
        Amount: this.newData.feeSumamt
      };
      NoSelfPayment(data).then(resUlt => {
        if (resUlt.data.Result == true) {
          loading.hide();
          window.location.href = resUlt.data.Extend;
        } else {
          alert(resUlt.data.Content);
        }
      });

      // if (this.newData.ownpayAmt === "0.00") {
      //   NoSelfPayment(data).then(resUlt => {
      //     if (resUlt.data.Result == true) {
      //       loading.hide();
      //       this.$router.push({
      //         path: "/pay/outpatientpaysus",
      //         query: { outOrder: resUlt.data.Extend }
      //       });
      //     }
      //   });
      // } else {
      //   WeiXinChargeTwo(data).then(resData => {
      //     var returnString = resData.split("_");
      //     if (returnString[0] == "ok") {
      //       loading.hide();
      //       this.$router.push({
      //         path: "/pay/outpatientpaysus",
      //         query: { outOrder: returnString[1] }
      //       });
      //     } else if (returnString[0] == "cancel") {
      //       loading.hide();
      //       DeletePayRecord(returnString[1]).then(response => {
      //         if (response.data.Result) {
      //           _that.$dialog = weui.dialog({
      //             title: "提示",
      //             content: "支付失败"
      //           });
      //         } else {
      //           _that.$dialog = weui.dialog({
      //             title: "提示",
      //             content: response.data.Content
      //           });
      //         }
      //       });
      //     } else if (returnString[0] == "fail") {
      //       loading.hide();
      //       DeletePayRecord(returnString[1]).then(response => {
      //         if (response.data.Result) {
      //           _that.$dialog = weui.dialog({
      //             title: "提示",
      //             content: "支付失败"
      //           });
      //         } else {
      //           _that.$dialog = weui.dialog({
      //             title: "提示",
      //             content: response.data.Content
      //           });
      //         }
      //       });
      //     } else if (returnString[0] == "no") {
      //       loading.hide();
      //     } else {
      //       loading.hide();
      //     }
      //   });
      // }
    }
  }
};
</script>

<style>
.pages {
  background: #faf8fa;
  height: 98%;
  padding: 20px 12px 0;
}
.cont {
  background: #ffffff;
  border-radius: 10px;
  padding: 30px 15px 26px;
}
.title_text {
  letter-spacing: 1px;
  font-size: 15px;
  padding: 0 10px;
  text-align: center;
  font-weight: 600;
  color: #3a383b;
}
.money {
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  color: #3a383b;
  margin: 20px 0;
}
.btnPay {
  background: #60c676;
  border-radius: 4px;
  text-align: center;
  width: 50%;
  margin: 0 auto;
  height: 28px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 14px;
  line-height: 28px;
  color: #ffffff;
  padding: 6px 20px;
}
.text_bottom {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.text_bottom:nth-child(4) {
  margin-bottom: 0;
}
.font_text {
  color: #3a383b;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pay/toPay.vue